module.exports = __webpack_public_path__ + "02_long_yellow.fb7a3432.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/02_long_yellow.png
// module id = tjhD
// module chunks = 0